import { computed, getCurrentInstance } from 'vue';
export const useDateDefaultValue = () => {
  const { props } = getCurrentInstance();

  const datePickerType = computed(() => {
    let widgetType = props.selectedWidget.type;
    let format = props.selectedWidget.options.format;

    let formatArray = format
      .replace(/\/|年|月|日|时|分|秒|:/g, '-')
      .replace(/\s|\-$/g, '')
      .split('-');

    let pickerDateType = ['year', 'month', 'date', 'datetime', 'datetime', 'datetime'];

    if (widgetType === 'm-date' || widgetType === 'm-datetime') {
      return pickerDateType[formatArray.length - 1];
    } else if (widgetType === 'm-time') {
      return 'datetime';
    } else if (widgetType === 'm-date-range') {
      if (format.indexOf('s') >= 0) {
        return 'datetimerange';
      } else if (format.indexOf('D') >= 0) {
        return 'daterange';
      } else {
        return 'monthrange';
      }
    }
  });

  return {
    datePickerType,
  };
};
